/**
 * Shift Service
 * Handles all shift-related API calls
 * @module services/shifts/shiftService
 */

import httpClient from '@/utils/httpClient';
import { isValidId, createInvalidIdResponse } from '@/services/shared/validationHelpers';
import { ENDPOINTS, getEndpointPath } from '@/api/endpoints';

const shiftService = {
  /**
   * Get all shifts (optional filters: branchId, isActive, search, includeOrgWide)
   */
  getAll: async (params = {}) => {
    try {
      const response = await httpClient.get(getEndpointPath(ENDPOINTS.SHIFTS.BASE), {
        params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getById: async (id) => {
    if (!isValidId(id, 'Shift')) {
      return createInvalidIdResponse('Shift');
    }
    try {
      const response = await httpClient.get(getEndpointPath(ENDPOINTS.SHIFTS.BY_ID, id));
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  create: async (shiftData) => {
    try {
      const response = await httpClient.post(
        getEndpointPath(ENDPOINTS.SHIFTS.CREATE),
        shiftData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  update: async (id, shiftData) => {
    if (!isValidId(id, 'Shift')) {
      return createInvalidIdResponse('Shift');
    }
    try {
      const response = await httpClient.patch(
        getEndpointPath(ENDPOINTS.SHIFTS.UPDATE, id),
        shiftData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  delete: async (id) => {
    if (!isValidId(id, 'Shift')) {
      return createInvalidIdResponse('Shift');
    }
    try {
      const response = await httpClient.delete(getEndpointPath(ENDPOINTS.SHIFTS.DELETE, id));
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default shiftService;
